import FileSaver from 'file-saver';
import moment from "moment";

import { 
  getFilterData,
  getRegistrationsReport,
  getConsultantsClientsReport,
  getClientsReport,
  getClientsOnlineReport,
  getFeedstatReport,
} from '../../request';
import { checkAndRenewTokens, checkTokenError } from "./auth";
import { showErrorMessage, hideErrorMessage, showSuccessMessage } from "./ui";

//Формирование файла отчета
export const ANALYTICS_FILE_LOADING_START = "Analytics file loading start";
export const ANALYTICS_FILE_LOADED_SUCCESSFULLY = "Analytics file loaded successfully";
export const ANALYTICS_FILE_LOADING_FAILED = "Analytics file loading failed";

//Загрузка с сервера доступных фильтров
export const FILTER_DATA_LOADING_START = "Filter data loading start";
export const FILTER_DATA_LOADED_SUCCESSFULLY = "Filter data loaded successfully";
export const FILTER_DATA_LOADING_FAILED = "Filter data loading failed";

//Настройка параметров отчета
export const CHANGE_REPORT_TYPE = "Change report type";
export const CHANGE_DATE_RANGE = "Change date range";
export const CHANGE_CHECKED_USER_TAGS = "Change checked user tags";
export const CHANGE_CHECKED_CONTENT_TYPES = "Change checked content types";
export const SWITCH_ALL_USER_TAGS = "Switch all user tags";
export const SWITCH_ALL_CONTENT_TYPES = "Switch all content types";

//ФОРМИРОВАНИЕ ФАЙЛА ОТЧЕТА
const startFileLoading = () => ({
  type: ANALYTICS_FILE_LOADING_START
});

const fileLoadingSuccess = file => ({
  type: ANALYTICS_FILE_LOADED_SUCCESSFULLY,
  payload: { file }
});

const fileLoadingFailure = () => ({
  type: ANALYTICS_FILE_LOADING_FAILED,
});

//Загрузка с сервера файла отчета
export const getAnalyticsFileAsync = () => {
  return async (dispatch, getState) => {
    dispatch(startFileLoading());
    dispatch(hideErrorMessage());
    await dispatch(checkAndRenewTokens());

    //Сформируем payload
    const currentState = getState();
    //Тип отчета
    const type = currentState.analytics.type;
    //Чекбоксы
    const userTags = currentState.analytics.checkedUserTagIds;
    const contentTypes = currentState.analytics.checkedContentTypes;
    //Приведем даты к нужному формату и сформируем payload
    const payload = {
      from_date: moment(currentState.analytics.dateRange[0]).format('YYYY-MM-DD'),
      to_date: moment(currentState.analytics.dateRange[1]).format('YYYY-MM-DD'),
    };

    if ((type === 'clientsonline') && (userTags.length !== 0)) payload.user_tag_ids = userTags;
    if ((type === 'feedstat') && (contentTypes.length !== 0)) payload.content_type = contentTypes;

    //Выбор нужного метода и запрос к серверу
    let file;
    try {
      const accessToken = localStorage.getItem("accessToken");
      switch (type) {
        case 'registrations':
          file = await getRegistrationsReport(accessToken, payload);
          break;
        case 'consultantsclients':
          file = await getConsultantsClientsReport(accessToken, payload);
          break;
        case 'clients':
          file = await getClientsReport(accessToken, payload);
          break;
        case 'clientsonline':
          file = await getClientsOnlineReport(accessToken, payload);
          break;
        case 'feedstat':
          file = await getFeedstatReport(accessToken, payload);
          break;
        default:
          dispatch(showErrorMessage("Ошибка при загрузке отчета!"));
          break;
      }

      //Обработка полученного файла
      // \ufeff - позволяет прочитать русские символы в Excel в кодировке utf-8 (для других программ не нужно)
      const blob = new Blob(['\ufeff', file], {type: "text/csv;charset=utf-8,"});
      FileSaver.saveAs(blob, 'Report.csv');
    } catch (err) {
      dispatch(checkTokenError(err));
      dispatch(showErrorMessage("Ошибка при загрузке отчета!"));
      return dispatch(fileLoadingFailure());
    }
    dispatch(showSuccessMessage('Отчет успешно загружен'));
    return dispatch(fileLoadingSuccess(file));
  };
};

//ЗАГРУЗКА С СЕРВЕРА ДОСТУПНЫХ ФИЛЬТРОВ
const startFiltersLoading = () => ({
  type: FILTER_DATA_LOADING_START
});

const filtersLoadingSuccess = filterdata => ({
  type: FILTER_DATA_LOADED_SUCCESSFULLY,
  payload: { filterdata }
});

const filtersLoadingFailure = () => ({
  type: FILTER_DATA_LOADING_FAILED,
});

//Загрузка с сервера файла отчета
export const getFilterDataAsync = payload => {
  return async (dispatch) => {
    dispatch(startFiltersLoading());
    dispatch(hideErrorMessage());
    await dispatch(checkAndRenewTokens());
    let filterdata;
    try {
      const accessToken = localStorage.getItem("accessToken");
      filterdata = await getFilterData(accessToken, payload);
    } catch (err) {
      dispatch(checkTokenError(err));
      dispatch(showErrorMessage("Ошибка при загрузке возможных фильтров!"));
      return dispatch(filtersLoadingFailure());
    }
    return dispatch(filtersLoadingSuccess(filterdata));
  };
};

//НАСТРОЙКА ПАРАМЕТРОВ ОТЧЕТА
//Выбор типа отчета в выпадающем списке
export const changeReportType = value => ({
  type: CHANGE_REPORT_TYPE,
  payload: { value }
});

//Выбор промежутка дат
export const changeDateRange = dates => ({
  type: CHANGE_DATE_RANGE,
  payload: { dates }
});


//Переключение чекбокса типа клиента
export const changeCheckedUserTags = (index, newCheckedUserTagIds) => ({
  type: CHANGE_CHECKED_USER_TAGS,
  payload: { index, newCheckedUserTagIds }
});

//Переключение чекбокса типа контента
export const changeCheckedContentTypes = (index, newCheckedContentTypes) => ({
  type: CHANGE_CHECKED_CONTENT_TYPES,
  payload: { index, newCheckedContentTypes }
});

//Выбрать все или очистить все чекбоксы типа клиента
export const switchAllUserTags = (newUserTags, newCheckedUserTagIds) => ({
  type: SWITCH_ALL_USER_TAGS,
  payload: { newUserTags, newCheckedUserTagIds }
});

//Выбрать все или очистить все чекбоксы типа контента
export const switchAllContentTypes = (newContentTypes, newCheckedContentTypes) => ({
  type: SWITCH_ALL_CONTENT_TYPES,
  payload: { newContentTypes, newCheckedContentTypes }
});